import React from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    hasError?: boolean;
}

const Input: React.FC<InputProps> = ({ hasError = false, className = "", ...props }) => {
    return (
        <input
            className={`ui-input ${hasError ? "ui-input-error" : ""} ${className}`.trim()}
            {...props}
        />
    );
};

export default Input;
